import isNewConsumerApp from 'commons/isNewConsumerApp';

import ConsumerSearchBarNext from './consumer-search-modal-next';
import ConsumerSearchBarLegacy from './ConsumerSearchBarLegacy';

const ConsumerSearchBar = isNewConsumerApp
  ? ConsumerSearchBarNext
  : ConsumerSearchBarLegacy;

export default ConsumerSearchBar;
